import { jupiterContainer } from 'styled-system/patterns';

export const visualStyle = {
	visual: jupiterContainer({
		'--swiper-navigation-color': 'colors.jupiter.common.white',
		'--swiper-pagination-color': 'colors.jupiter.common.white',
		'--swiper-pagination-bullet-inactive-color': 'colors.jupiter.common.white',
		'--swiper-pagination-bullet-inactive-opacity': '0.6',
	}),
}